






























































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { Choice } from "@/api/model/Choice";
import ChoiceInputFormRecursiveGroup from "@/components/choice-input/form/ChoiceInputFormRecursiveGroup.vue";
import ImagePicker from "@/components/common/ImagePicker.vue";
import Sticky from "vue-sticky-directive";
import { ChoiceInputFactorResource } from "@/types/ChoiceInputFactorResource";

@Component(
    {
        components: {
            ImagePicker,
            ChoiceInputFormRecursiveGroup,
        },
        directives: {Sticky},
    })
export default class ChoiceInputForm extends Vue {

    @Prop()
    name!: string;

    @Prop()
    description!: string;

    @Prop()
    choiceForm!: Choice;

    @Prop()
    modelFactorResources!: { [id: string]: ChoiceInputFactorResource };

    @Prop()
    submitting!: boolean;

    @Prop({
        type: Object,
        default: () => ({})
    })
    styles!: any;

    @Prop()
    disabled!: boolean;

    private rules = {
        required: (value: string) => !!value || 'Required'
    };

    @Emit()
    private async submit() {
    }

}
